/**
 * The base map under the dossier's maps (Location and Comparables).
 *
 * Light, never dark (Edward, 29 Oct 2026). It was OpenFreeMap's Positron, a
 * near-monochrome style: grey water, parks a shade off white, land almost
 * white. On the dossier's black page it read as a white square (Edward, 30 Oct
 * 2026: "why do the maps show up so white looking?"). Liberty is light too, and
 * draws water blue, parks green and land warm, so the place reads at a glance.
 */
export const LIGHT_MAP_STYLE = 'https://tiles.openfreemap.org/styles/liberty'
